import { createSelector } from 'reselect'

export const getData = state => state.generalSettings.getIn(['all', 'objects'])
export const getFetching = state => state.generalSettings.getIn(['all', 'fetching'])
export const getError = state => state.generalSettings.getIn(['all', 'error'])

const getCurrentSettingStatus = state => state.generalSettings.get('current')
export const createGetCurrentSettingStatusSelector = () => createSelector([getCurrentSettingStatus], status => status)